import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 15000,
});

export const sendAppointment = (data) => api.post("/appointments", data);
export const sendApplication = (data) => api.post("/applications", data);
export const sendContact = (data) => api.post("/contact", data);
export const checkAvailability = (date, time) => api.get(`/appointments/check?date=${date}&time=${time}`);

export const adminLogin = (password) => api.post("/admin/login", { password });
export const getAdminAppointments = (token) =>
  api.get("/admin/appointments", { headers: { Authorization: `Bearer ${token}` } });
export const setAppointmentStatus = (token, id, status) =>
  api.post(`/admin/appointments/${id}/status`, { status }, { headers: { Authorization: `Bearer ${token}` } });
export const getPublicSettings = () => api.get("/settings/public");
export const saveAdminSettings = (token, data) =>
  api.post("/admin/settings", data, { headers: { Authorization: `Bearer ${token}` } });
